module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }]
  }, [_vm._c('div', {
    attrs: {
      "id": "gv-legend-maps"
    }
  }, _vm._l((_vm.maps), function(map) {
    return _vm._c('ul', {
      key: map.id,
      staticClass: "gv-list-group"
    }, [_vm._c('div', {
      staticClass: "gv-list-legend-map-item gv-inverted-color-scheme"
    }, [_vm._c('li', [_vm._v(_vm._s(map.name))]), _vm._v(" "), _vm._c('div', {
      staticClass: "gv-legend-map-tools gv-inverted-color-scheme"
    }, [(!_vm.options.noToggleLayers) ? _vm._c('el-button', {
      class: _vm.getToggleLayersClass(map),
      attrs: {
        "title": "Mostra/Nascondi Livelli in Legenda",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toggleLayers(map)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.checkInfoMap(map)) ? _vm._c('el-button', {
      staticClass: "gv-inverted-color-scheme gv-legend-map-tools-button",
      attrs: {
        "id": 'gv-legend-scheda-' + map.id,
        "title": "Visualizza Scheda",
        "icon": "el-icon-document",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.showMapInfoPanel(map)
        }
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.options.noDeleteButton) ? _vm._c('el-button', {
      staticClass: "gv-inverted-color-scheme gv-legend-map-tools-button",
      attrs: {
        "id": 'gv-legend-delete-' + map.id,
        "title": "Elimina Mappa",
        "icon": "el-icon-delete",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.remove(map)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.options.showLayersTransparency) ? _vm._c('el-button', {
      staticClass: "gv-inverted-color-scheme gv-legend-map-tools-button",
      attrs: {
        "id": 'gv-legend-transparency-' + map.id,
        "title": "Trasparenza Livelli",
        "icon": "el-icon-setting",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.layerTransparency(map)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isDownloadable(map)) ? _vm._c('el-button', {
      staticClass: "gv-inverted-color-scheme gv-legend-map-tools-button",
      attrs: {
        "id": 'gv-legend-download-' + map.id,
        "title": "Download Mappa",
        "icon": "el-icon-download",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.download(map)
        }
      }
    }) : _vm._e()], 1)]), _vm._v(" "), _vm._c('gv-legend-layers', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showMapLayers(map)),
        expression: "showMapLayers(map)"
      }],
      attrs: {
        "map": map,
        "options": _vm.options
      }
    })], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6118930c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LegendMaps.vue
// module id = 876
// module chunks = 39